import { Component, Input } from '@angular/core';
import { InfoItemModel, InfoItemType } from '../models/info-item.model';
import { SendEmailStatusEnum } from '../../../../models';
import { CURRENCIES_SYMBOLS_BY_ISO_CODE } from 'projects/workspace/src/app/accounting/accounting.constants';
import { Store } from '@ngrx/store';
import { AppState } from 'projects/workspace/src/app/store/state/app.state';
import { selectCompanyTimezoneOffset } from 'projects/workspace/src/app/administration/store/selectors';
import { Observable } from 'rxjs';
import { EMAIL_SENT_STATUS_CLASSES } from 'projects/workspace/src/app/shared/constants';

@Component({
  selector: 'rnpl-info-item',
  templateUrl: './info-item.component.html',
  styleUrls: ['./info-item.component.scss']
})
export class InfoItemComponent {

  @Input() public infoItem: InfoItemModel = null;

  readonly ITEM_TYPES: typeof InfoItemType = InfoItemType;
  readonly sendEmailStatusEnum = SendEmailStatusEnum;
  readonly currenciesSymbols = CURRENCIES_SYMBOLS_BY_ISO_CODE;

  readonly companyProfileTimezoneOffset$: Observable<string> = this.store.select(selectCompanyTimezoneOffset);

  public emailSentStatusClasses: {[key: string]: string } = EMAIL_SENT_STATUS_CLASSES;

  constructor(
    private readonly store: Store<AppState>,
  ) {}

}
